import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';

import { LoaderInterceptor, LoaderService } from '@shared/services/ui';

export function provideLoader(): Provider[] {
  return [
    LoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
  ];
}
